<template>
    <layout v-bind:user="user" v-bind:brands="brands" v-bind:company="company" title="ショールーム Sales Brands Info一覧" @selectList="displaySelectedBrand($event)">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>Sales Brands Info</span></div>
            </h1><!--/.heading_page-title-->
            <!--ShopList-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="_pointer" @click="clickSort('id')">ID {{getTriangle('id')}}</th>
                                    <th class="_pointer" @click="clickSort('name')">名前 {{getTriangle('name')}}</th>
                                    <th class="_pointer" @click="clickSort('status')">ステータス {{getTriangle('status')}}  {{status_count}}/{{subscription_upper}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!--Item-->
                                <tr v-for="(salesBrand, index) in salesBrandsList" v-bind:key="index">
                                    <td>{{salesBrand.id}}</td>
                                    <td>{{salesBrand.name}}</td>
                                    <td>
                                        <select v-on:change="selectStatus($event, salesBrand)">
                                            <option value="" hidden>審査待ち</option>
                                            <option v-for="select_status in select_statuses"
                                                    v-bind:selected="select_status.id == salesBrand.get_sales_brand.status"
                                                    v-bind:key="select_status.id"
                                                    v-bind:value="select_status.id">
                                                    {{ select_status.name }}
                                            </option>
                                        </select>
                                    </td>

                                </tr><!--/.Item-->
                            </tbody>
                        </table>
                        <pagination v-if="showPagination" :list="links" />
                    </div><!--/.table_common-->
                </div><!--/.md_common-bl-->
                <AlertModal
                    v-if="showAlertModal"
                    @close="closeAlertModal"
                    :title="alert_modal_title"
                    :message="alert_modal_message"
                    :mode="alert_modal_mode"
                />
            </div>
        </div></div><div class="heading_page-title-en"><span>ShowRoom</span></div></main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'

    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'
    import SvgIconSetting from '@/components/EndUser/svg/SvgIconSetting'

    import ScrollHint from 'scroll-hint';

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "AlertModal": AlertModal,
            "ScrollHint": ScrollHint,
            //Svg
            SvgIconEdit,
            SvgIconAdd,
            SvgIconSetting,
        },
        data() {
            return {
                list_index: 0,
                showPagination: false,
                links: '',
                select_id: 0,
                brand_id: 0,
                list_sorter: {column: "", order: ""},
                select_statuses: [
                    { id: 1, name: '承認'},
                    { id: 2, name: '非承認'},
                ],
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
                subscription_upper: '',
                plan_validation: false,
                count_validation: false,
            }
        },
        props: {
            user: Object,
            company: Object,
            brands: Object,
            sales_brands: Object,
            subscription_count: Object,
            status_count: Object,
            listIndex: Object,
            listSorter: Object,
        },
        created() {
            this.setDefaultData();
        },
        mounted() {
            new ScrollHint('.table_common');
        },
        methods: {
            displaySelectedBrand(index) {
                this.list_index = index;
                var brand = this.brands[this.list_index];
                this.brand_id = brand.id;
                if (brand.plan == 1 && (brand.subscription_status == 'active' || brand.subscription_status == 'onGracePeriod')) {
                    this.getShowRoomSalesBrands();
                } else {
                    this.plan_validation = true;
                    this.openAlertModal('error', 'BASICプランのみのご利用になります', 'BASICプランのみのご利用になります'); // 確認済み
                }
            },
            setDefaultData() {
                this.list_index = this.listIndex;
                this.$store.state.const.index = this.listIndex;
                var brand = this.brands[this.list_index];
                this.brand_id = brand.id;

                if (this.sales_brands.data) {
                    this.showPagination = true;
                }
                for(var i in this.sales_brands.links) {
                    var link = this.sales_brands.links[i];
                    if (link.url) {
                        link.url = link.url + '&listIndex=' + this.listIndex;
                    }
                }
                if (this.listSorter) {
                    this.addSorterToLinks(this.listSorter, this.sales_brands.links);
                }
                this.links = this.sales_brands;
                if(this.listSorter){
                    this.list_sorter = this.listSorter;
                }

                this.subscription_upper = this.subscription_count * 10;
            },
            getShowRoomSalesBrands() {
                const form = reactive({
                    listIndex: this.list_index,
                })
                Inertia.get('/admin/showroom/sales_brands', form, {
                    onSuccess: (page) => {
                    },
                })
            },
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    listIndex: this.list_index,
                    listSorter: { column, order }
                })
                Inertia.get(location.pathname, form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            },
            selectStatus(event, item) {
                var selectStatusId = event.target.value;
                var id = item.id
                var url = '/admin/showroom/sales_brands/status'

                // 承認済みを選んだ場合
                if (selectStatusId == 1) {
                    // 決済1度につき10プラン
                    if (this.subscription_upper <= this.status_count) {
                        this.count_validation = true;
                        this.openAlertModal('error', '課金をする必要があります', 'Sales Brands Infoに追加できるブランドは、1プランに付き10ブランドまでです。これ以上Sales Brands Infoを増やすには、ショールーム一覧のプランから課金をする必要があります'); // 確認済み
                        return;
                    }
                }

                const form = reactive({
                    id: id,
                    status: selectStatusId,
                    showroom_id: this.brand_id,
                    listIndex: this.list_index,
                })
                Inertia.post(url, form, {
                    onSuccess: (page) => {
                        if (selectStatusId == 1) {
                            this.openAlertModal("success", "承認しました", '承認しました。');
                        } else {
                            this.openAlertModal("success", "承認しませんでした", '承認しませんでした。');
                        }
                    },
                })
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';

                if (this.plan_validation){
                    Inertia.get(route('admin.showroom.dashboard'));
                }
                if (this.count_validation){
                    location.reload();
                }
            },
        },
        computed: {
            salesBrandsList() {
                this.list_index = this.listIndex;
                this.$store.state.const.index = this.listIndex;
                if (this.sales_brands.data) {
                    this.showPagination = true;
                    this.links = this.sales_brands;
                }
                if (this.listSorter) {
                    this.addSorterToLinks(this.listSorter, this.sales_brands.links);
                }
                return this.sales_brands.data;
            },
        }
    }
</script>
